import { format, addYears } from 'date-fns';
import { adjustDateForTimezone } from 'helpers/intl-fns';
import { SERVER_DATE_FORMAT } from 'constants/logic';
import { calendarAvailability } from 'store/saga/entities/bound';

export const getCalendarAvailabilityKey = (venueId, venueTimezone) => {
  const now = new Date();
  const nowInVenueTimezone = adjustDateForTimezone(now, venueTimezone);
  const startDate = format(nowInVenueTimezone, SERVER_DATE_FORMAT);
  const endDate = format(addYears(nowInVenueTimezone, 1), SERVER_DATE_FORMAT);

  return calendarAvailability.defaultKey(null, venueId, startDate, endDate);
};
